import { createRouter, createWebHashHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'
import WechatAuth from '@/components/common/WechatAuth.vue'
import HomeView from '../views/HomeView.vue'
import BindPhone from '@/views/BindPhone.vue' // 绑定手机号页面


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { 
      title: '叶婆手作 - 首页',
      requiresAuth: false,
      isWork:false
    }
  },
   {
    path: '/bind-phone',
    name: 'BindPhone',
    component: BindPhone, // 绑定手机号页面
    meta: {
       title: '绑定手机号',
        requiresAuth: true,
        isWork:false
      }
  },
  {
    path: '/wechat-auth',
    name: 'WechatAuth',
    component: WechatAuth,
    props: (route) => ({ redirectPath: route.query.redirect || '/' }),
    meta: { 
      title: '微信授权',
      requiresAuth: false, // 不需要认证
      isWork:false
    }
  },
   {
    path: '/member-center',
    name: 'memberCenter',
    component: () => import('../views/MemberCenter.vue'),
     meta: {
       title: '会员中心',
       requiresAuth: true,
       isWork:false
      }
  },
  {
    path: '/product-selection',
    name: 'ProductSelection',
    component: () => import('../components/member/ProductSelection.vue'),
     meta: {
       title: '产品选择',
        requiresAuth: true,
        isWork:false 
      }
  },
  {
    path: '/qr-display/:qrId',
    name: 'QRCodeDisplay',
    component: () => import('../components/member/QRCodeDisplay.vue'),
    meta: { 
      title: '核销二维码',
      requiresAuth: true,
      isWork:false
    },
    props: true
  },
  {
    path: '/usage-history',
    name: 'UsageHistory',
    component: () => import('../components/member/UsageHistory.vue'),
    meta: { 
      title: '核销二维码',
      requiresAuth: true,
      isWork:false
    },
    props: true
  },
  {
    path: '/group-user',
    name: 'GroupUser',
    component: () => import('../views/front/GroupView.vue'),
    meta: { 
      title: '核销二维码',
      requiresAuth: false,
      isWork:false
    },
    props: true
  },

// 企业微信路由

 {
    path: '/staff-login',
    name: 'staffLogin',
    component: () => import('../components/workWechat/login/loginIndex.vue'),
    meta: { 
      title: '员工登录',
      requiresAuth: false,
      isWork:true
    }
  },

    {
    path: '/workbench',
    name: 'Workbench',
   // redirect: '/index', // 添加重定向
    component: () => import('../views/workChatView.vue'),
    meta: { 
      title: '首页',
      requiresAuth: true,
      isWork:true,
      keepAlive: true
    },
    children: [
    {
      path: 'qr-scanner',
      name: 'QRCodeScanner',
      component: () => import('../components/member/QRCodeScanner.vue'),
      meta: { 
        title: '核销二维码',
        requiresAuth: true,
        isWork:true
      }
    },
    {
      path: 'shop-turnover',
      name: 'shopTurnover',
      component: () => import('../components/workWechat/shop/shopTurnover.vue'),
      meta: { 
        title: '业绩上报',
        requiresAuth: true,
        isWork:true
      }
    },

      {
      path: 'shop-turnover/shop-turnover-history',
      name: 'shopTurnoverHistory',
      component: () => import('../components/workWechat/shop/turnnover/shopTurnoverHistory.vue'),
      meta: { 
        title: '业绩上报记录',
        requiresAuth: true,
        isWork:true
      }
    },
    {
      path: 'shop-inventory',
      name: 'shopInventory',
      component: () => import('../components/workWechat/shop/inventory/ShopInventory.vue'),
      meta: { 
        title: '库存盘点',
        requiresAuth: true,
        isWork:true
      },
    },
  
    {
      path: 'shop-loss',
      name: 'shopLoss',
      component: () => import('../components/workWechat/shop/loss/shopLoss.vue'),
      meta: { 
        title: '损耗上报',
        requiresAuth: true,
        isWork:true
      },
    },
    {
      path: 'shop-loss/shop-loss-history',
      name: 'shopLossHistory',
      component: () => import('../components/workWechat/shop/loss/LossHistoryList.vue'),
      meta: { 
        title: '损耗记录',
        requiresAuth: true,
        isWork:true
      },
    }
    ]
  },
   {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('../components/workWechat/index/indexVue.vue'),
    meta: { 
      title: '首页',
      requiresAuth: true,
      isWork:true
    }
  },
   {
    path: '/profile',
    name: 'Profile',
    component: () => import('../components/workWechat/staff/profileView.vue'),
    meta: { 
      title: '首页',
      requiresAuth: true,
      isWork:true
    }
  }
  
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

/**
 * 检查token是否有效
 * @returns {Boolean} token是否有效
 */
const isTokenValid = () => {
  const authStore = useAuthStore()
  return authStore.token 
}

/**
 * 全局前置路由守卫
 * 在每次路由跳转前执行，用于设置页面标题等全局操作
 */
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '叶婆手作'
  //判断是否需要授权检查 （微信端）
   if (to.meta.requiresAuth && to.meta.isWork ===false ) {
     
    //const authStore = useAuthStore()
    
    // 检查是否已微信授权
    // if (!authStore.isWechatAuthorized) {
    //     alert(111)
    //   // 未授权，跳转到微信授权页面，并携带重定向路径
    //   next({
    //     path: '/wechat-auth',
    //     query: { redirect: to.fullPath }
    //   })
    //   return
    // }
    
    // 检查token是否有效
    if (!isTokenValid()) {
      // token失效，跳转到微信授权页面，并携带重定向路径
      next({
        path: '/wechat-auth',
        query: { redirect: to.fullPath }
      })
      return
    }
  }

  // 企业微信后台
  if (to.meta.requiresAuth && to.meta.isWork === true ){
     const staffToken = localStorage.getItem('staff_token')
     if(!staffToken){
        next({
        path: '/staff-login',
        query: { redirect: to.fullPath }
      })
      return
     }
  }

  next()
})

export default router
